export const rolesOptions = (rol)=>{
    let rolesOptions = [];
    if (rol === "superadmin") {
        rolesOptions = [
          { value: "superadmin", label: "Super Admin" },
          { value: "admin", label: "Admin" },
          { value: "vendedor", label: "Vendedor" },
        ];
      } else {
        rolesOptions = [
          { value: "admin", label: "Admin" },
          { value: "vendedor", label: "Vendedor" },
        ];
      }
      return rolesOptions
}